import { produce } from "immer";
import * as C from "./GlanceConstants";
import { STATUS_PENDING, STATUS_SUCCESS, STATUS_FAILURE, GENERIC_ERROR_MESSAGE } from "Common/constants/commonConstants";

const screenInitialState = {
  fetchStatus: STATUS_SUCCESS,
  fetchErrorMessage: "",
  data: [],
};

const initialState = {};

// Lazily ensure device + screen slot exists
const ensureScreen = (draft, deviceId, screenKey) => {
  if (!draft[deviceId]) draft[deviceId] = {};
  if (!draft[deviceId][screenKey]) draft[deviceId][screenKey] = { ...screenInitialState };
};

export default function DXHReducer(state = initialState, action) {
  switch (action.type) {
    // Device State
    case C.DXH_DEVICE_STATE_ADD: {
      if (state[action.payload]) return state;
      return produce(state, (draft) => {
        draft[action.payload] = {};
      });
    }
    case C.DXH_DEVICE_STATE_REMOVE: {
      return produce(state, (draft) => {
        delete draft[action.payload];
      });
    }

    // Generic fetch request
    case C.DXH_SCREEN_FETCH_REQUEST: {
      const { screenKey, deviceId, keepExisting, clearKeys } = action.payload;
      return produce(state, (draft) => {
        ensureScreen(draft, deviceId, screenKey);
        const existing = draft[deviceId][screenKey];
        let data = keepExisting ? (typeof existing.data === "object" && existing.data ? { ...existing.data } : existing.data) : [];
        if (clearKeys && typeof data === "object" && data) {
          clearKeys.forEach((k) => { delete data[k]; });
        }
        draft[deviceId][screenKey] = {
          fetchStatus: STATUS_PENDING,
          fetchErrorMessage: "",
          data,
          pagination: keepExisting ? existing.pagination : null,
        };
      });
    }

    // Generic fetch success
    case C.DXH_SCREEN_FETCH_SUCCESS: {
      const { screenKey, deviceId, result, pagination, mergeResult } = action.payload;
      return produce(state, (draft) => {
        ensureScreen(draft, deviceId, screenKey);
        const existingData = draft[deviceId][screenKey].data;
        draft[deviceId][screenKey] = {
          fetchStatus: STATUS_SUCCESS,
          fetchErrorMessage: "",
          data: mergeResult && existingData && typeof existingData === "object" ? { ...existingData, ...result } : result,
          pagination: pagination || null,
        };
      });
    }

    // Generic fetch error
    case C.DXH_SCREEN_FETCH_ERROR: {
      const { screenKey, deviceId } = action.payload;
      return produce(state, (draft) => {
        ensureScreen(draft, deviceId, screenKey);
        draft[deviceId][screenKey] = {
          fetchStatus: STATUS_FAILURE,
          fetchErrorMessage: GENERIC_ERROR_MESSAGE,
          data: [],
          pagination: null,
        };
      });
    }

    // Pagination append
    case C.DXH_FETCH_PAGE_APPEND: {
      const { screenKey, deviceId, result, pagination } = action.payload;
      return produce(state, (draft) => {
        ensureScreen(draft, deviceId, screenKey);
        const existing = draft[deviceId][screenKey].data?.systemStatus || [];
        draft[deviceId][screenKey] = {
          fetchStatus: STATUS_SUCCESS,
          fetchErrorMessage: "",
          data: { systemStatus: [...existing, ...(result.systemStatus || [])] },
          pagination: pagination || null,
        };
      });
    }

    // Dashboard tile status cache (statusData, groups, tileTypes per device)
    case C.DXH_DASHBOARD_STATUS_SUCCESS: {
      const { deviceId, statusData, groups, tileTypes } = action.payload;
      return produce(state, (draft) => {
        if (!draft[deviceId]) draft[deviceId] = {};
        draft[deviceId]._dashboard = { statusData, groups, tileTypes };
      });
    }

    default:
      return state;
  }
}
